// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

let ContentRect = {};

function create(cb) {
  return new ResizeObserver(v => {
    requestAnimationFrame(param => {
      if (Array.isArray(v) && v.length !== 0) {
        return cb(v);
      }
    });
  });
}

let hasSupport = (function() { return window && !!window.ResizeObserver });

function useElementSize(elementRef) {
  let match = React.useState(() => [
    0,
    0
  ]);
  let setElementSize = match[1];
  React.useEffect(() => {
    let match = hasSupport();
    let match$1 = elementRef.current;
    if (!match) {
      return;
    }
    if (match$1 === undefined) {
      return;
    }
    let e = Primitive_option.valFromOption(match$1);
    let observer = create(entries => {
      entries.forEach(e => setElementSize(param => [
        e.contentRect.height,
        e.contentRect.width
      ]));
    });
    observer.observe(e);
    return () => {
      observer.unobserve(e);
    };
  }, [elementRef]);
  return match[0];
}

exports.ContentRect = ContentRect;
exports.create = create;
exports.hasSupport = hasSupport;
exports.useElementSize = useElementSize;
/* react Not a pure module */
